export const SignOut = () =>
{
    return(
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M11.6667 2.57918C11.2858 2.52701 10.8963 2.5 10.5 2.5C6.08173 2.5 2.5 5.85787 2.5 10C2.5 14.1422 6.08173 17.5 10.5 17.5C10.8963 17.5 11.2858 17.473 11.6667 17.4208" stroke="#141B34" strokeWidth="1.5" strokeLinecap="round"/>
<path d="M17.5 10.0001H9.16663M17.5 10.0001C17.5 9.41658 15.838 8.32636 15.4166 7.91675M17.5 10.0001C17.5 10.5836 15.838 11.6738 15.4166 12.0834" stroke="#141B34" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
</svg>

    )
}

